




























import Vue from "vue";

import { IPost, IState } from "../store/state";
import { toggleFilterValue, clearAllFilters } from "../store/actions";

interface IBlogPostComputed {
  link: string;
}

interface IBlogPostMethods {
  toggleTag(tagName: string): void;
  tagRoute(tagName: string): string;
}

export default Vue.extend<{}, IBlogPostMethods, IBlogPostComputed, IPost>({
  props: {
    id: String,
    title: String,
    ingress: String,
    uri: String,
    date: String,
    dateLong: Number,
    tags: Array,
    images: Array
  },
  computed: {
    link() {
      return this.uri;
    }
  },
  methods: {
    toggleTag(tagName) {
      const tagValue = (this.$store.state as IState).filters.tags.values.find(
        ft => ft.name === tagName
      );
      if (tagValue) {
        this.$store.dispatch(
          clearAllFilters({
            name: "tags",
            value: tagValue
          })
        );
      }
    },
    tagRoute(tagName) {
      const tagValue = (this.$store.state as IState).filters.tags.values.find(
        ft => ft.name === tagName
      );

      const url = this.$store.getters.searchUrl([tagValue], []);
      return url;
    }
  }
});
